import { Alert, Tag } from 'antd';
import { Button } from 'common/ui/button';
import { useAdminAccount } from 'hooks/use-admin-account';
import { Link } from 'react-router-dom';
import { ItemState, securityChecklist } from './account-security-checklist';

const stateTag: Record<ItemState, { color: string; icon: string }> = {
  done: { color: 'green', icon: '✓' },
  todo: { color: 'orange', icon: '!' },
  off: { color: 'default', icon: '–' },
};

export default function AccountSecurity() {
  const { data: account, isLoading } = useAdminAccount();

  const renderBody = () => {
    if (isLoading) {
      return <div className="text-center text-gray-500">Đang tải...</div>;
    }
    if (!account) {
      return (
        <Alert type="error" showIcon message="Không tải được tài khoản." />
      );
    }

    const items = securityChecklist(account);
    const todo = items.filter(item => item.state === 'todo').length;
    return (
      <div className="space-y-4">
        {todo > 0 ? (
          <Alert
            type="warning"
            showIcon
            message={`Còn ${todo} mục nên hoàn thành để bảo vệ tài khoản.`}
          />
        ) : (
          <Alert type="success" showIcon message="Tài khoản đã được bảo vệ." />
        )}
        <ul className="divide-y">
          {items.map(item => (
            <li key={item.key} className="flex gap-3 py-4">
              <Tag
                color={stateTag[item.state].color}
                className="h-6 w-6 !mr-0 flex shrink-0 items-center justify-center"
              >
                {stateTag[item.state].icon}
              </Tag>
              <div className="flex-1 space-y-1">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="font-medium">{item.title}</span>
                  <span className="text-sm text-gray-500">{item.status}</span>
                </div>
                <p className="text-sm text-gray-600">{item.description}</p>
                {item.action && (
                  <Link to={item.action.to}>
                    <Button
                      size="sm"
                      variant={item.state === 'todo' ? 'default' : 'outline'}
                      className="mt-1"
                    >
                      {item.action.label}
                    </Button>
                  </Link>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <div className="w-full max-w-lg rounded-lg bg-white p-8 shadow-md">
        <h2 className="mb-6 text-2xl font-bold text-center">
          Bảo mật tài khoản
        </h2>
        {renderBody()}
      </div>
    </div>
  );
}
